module.exports = __webpack_public_path__ + "media/images/foot_left-25bdcb32ab4716d2d200b90bb2f6a428.gif";